// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"Breadcrumbs_pattern-gradient__Vr5QJ","breadcrumbs":"Breadcrumbs_breadcrumbs__4wVJr"};